<template>
  <div class="container" id="vue-progress-bar">
    <span class="percentage_value">{{value}}% Complete</span>
    <div class="progress">
      <div
        class="progress-bar progress-bar-success"
        role="progressbar"
        :aria-valuenow="value"
        aria-valuemin="0"
        aria-valuemax="100"
        :style="{width:value + '%'}"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  computed: {
    value: function() {
      return this.$store.state.progressValue;
    }
  }
};
</script>
